import { render, staticRenderFns } from "./document-input-field.vue?vue&type=template&id=fc0e4c7a&"
import script from "./document-input-field.vue?vue&type=script&lang=js&"
export * from "./document-input-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "document-input-field.vue"
export default component.exports